var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star_svg__clip0_10876_34130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.062 2.177l3.363 6.813 7.521 1.1-5.442 5.3 1.284 7.488-6.726-3.537-6.727 3.537L7.62 15.39l-5.442-5.3 7.52-1.1 3.364-6.813z",
    stroke: "#fff",
    strokeWidth: 3.265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_svg__clip0_10876_34130"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26.122v26.122H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/star.db0e8127.svg";
export { SvgStar as ReactComponent };